import { Component, Input } from '@angular/core';

import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { FieldLabelComponent } from '../../../ui/forms/field-label/field-label.component';
import { FieldErrorComponent } from '../../../ui/forms/field-error/field-error.component';
import { BaseControlComponent } from '../base-control/base-control.component';

@Component({
	selector: 'app-textarea-control',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, FieldLabelComponent, FieldErrorComponent],
	templateUrl: './textarea-control.component.html',
	styleUrls: ['./textarea-control.component.scss'],
})
export class TextareaControlComponent extends BaseControlComponent {
	@Input('type') public type: string = 'text';
}
